import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { ColumnBreakNodeView } from "@/components/editor/nodeviews/ColumnBreakNodeView";

export const ColumnBreakBlock = Node.create({
  name: "columnBreakBlock",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      blockId: { default: null },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="column-break-block"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes, { "data-type": "column-break-block" })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(ColumnBreakNodeView);
  },
});
